import { Component } from '@angular/core';
import { GameTicket, GameType } from '@app/@shared/models/game.model';
import { MelateTicket } from '@app/@shared/models/melate.model';
import { ModalController } from '@ionic/angular';
import { Touch } from '@app/@shared/models/quiniela.model';
import { PartidoInterface } from '@app/@shared/models/prono-sports.model';
import { SafeHtmlPipe } from '@app/@shared/pipes/safe-html.pipe';
import { TrackingService } from '@app/@shared/services/tracking.service';

@Component({
  selector: 'app-confirm-payment',
  templateUrl: './confirm-payment.component.html',
  styleUrl: './confirm-payment.component.scss',
  providers: [SafeHtmlPipe],
})
export class ConfirmPaymentComponent {
  amount = 0;
  tickets: GameTicket[] = [];
  type!: GameType;

  melates: MelateTicket[] = [];
  isRetro = false;
  isMediaSemana = false;
  isCoperacha = false;
  touches: Touch[] = [];
  tracking!: TrackingService;
  constructor(
    private modalCtrl: ModalController //public trackingS: TrackingService
  ) {}

  close() {
    this.modalCtrl.dismiss(null, 'close');
  }

  acceptPayment() {
    //console.log('Aceptando pago: ', this.tickets);
    this.modalCtrl.dismiss(null, 'accept');
  }
  changeRemember(ev: CustomEvent) {
    //console.log(ev.detail['checked']);
    localStorage.setItem('skip-confirmation', JSON.stringify(ev.detail['checked']));
  }

  isPartidoInterface(ticket: any): ticket is PartidoInterface {
    if (!ticket || typeof ticket !== 'object') return false;
    return ticket.nameLocal !== undefined && ticket.nameVisitante !== undefined && ticket.option !== undefined;
  }

  functionToFormat(tickets: any): PartidoInterface[] {
    if (!tickets || typeof tickets !== 'object') return [];

    if (tickets.opciones && typeof tickets.opciones === 'object') {
      const partidos: PartidoInterface[] = [];

      Object.keys(tickets.opciones).forEach((key) => {
        const opcion = tickets.opciones[key];

        if (Array.isArray(opcion)) {
          opcion.forEach((item) => {
            if (this.isPartidoInterface(item)) {
              partidos.push(item);
            }
          });
        } else if (this.isPartidoInterface(opcion)) {
          partidos.push(opcion);
        }
      });

      return partidos;
    }

    return [];
  }

  getKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  getOpcionesArray(opciones: any): any[] {
    if (!opciones) return [];
    if (Array.isArray(opciones)) return opciones;
    if (typeof opciones === 'object') return Object.values(opciones);
    return [];
  }
  formatTicketData(data: any): string {
    if (!data) return '<div class="ticket-message">Sin datos</div>';

    let result = '<div class="ticket-container">';
    let totalMomio = 1;
    let momios = 0;
    let totalInd = data.totalIndividual || data.totalAmount;

    // Tipos de apuesta (abreviaciones)
    const tiposApuesta: { [key: string]: string } = {
      'Resultado Final': 'RF',
      'Total de Goles': 'TG',
      'Medio Tiempo': 'MT',
      'Doble Oportunidad': 'DO',
      'Primera Mitad': 'PM',
      'Ambos Equipos Anotan': 'AA',
      'Ganador Medio Tiempo': 'MT',
    };

    if (data.opciones) {
      result += '<div class="partidos-list">';
      if (data.ticket === 'combined' && data.quiniela) {
        result += `
          <div class="quiniela-info">
            <span class="quiniela-label">${data.quiniela.label}</span>
            <span class="quiniela-q">${data.quiniela.Q}</span>
          </div>`;
      }

      for (const partidoId in data.opciones) {
        const opciones = data.opciones[partidoId];
        const partidos = Array.isArray(opciones) ? opciones : [opciones];

        partidos.forEach((partido) => {
          const abreviacion = partido.apuesta ? tiposApuesta[partido.apuesta] || partido.apuesta : 'N/A';
          const [optionText, optionValue] = partido.option?.split('/') || ['N/A', '0'];

          result += `
          <div class="partido-item">
            <div class="partido-header" style="margin-top:20px;">
              <span class="partido-id">Partido ${partidoId}:</span>
            </div>
            <div class="partido-details" style="padding-left:20px;"> <!-- Desplaza hacia la derecha -->
              <div class="teams">${partido.nameLocal || 'N/A'} vs ${partido.nameVisitante || 'N/A'}</div>
              <div class="date">${partido.endRow || 'N/A'}</div>
          
              <div class="bet-info">
                <span class="bet-type">${abreviacion}</span>
                <span class="bet-option">${optionText.trim()}</span>
                <span class="bet-value">${optionValue ? '/' + optionValue.trim() : ''}</span>
              </div>
            </div>
  
            <!-- Espacio "fantasma" entre partidos -->
            <div class="ghost-space" style="height:15px;"></div>
  
          </div>\n`; // Añadido salto de línea después de cada partido

          if (data.ticket === 'individual') {
            result += `
            <div class="costo-info">
              <span class="costo-label">Costo:</span>
              <span class="costo-value">$${data.totalIndividual}</span>
            </div>\n`; // Salto de línea después del costo
          }
        });
      }
      result += '</div>'; // Cierre de partidos-list
    }

    // Lógica específica por tipo de ticket
    switch (data.ticket) {
      case 'combined':
        if (data.quiniela) {
          const baseBalance = data.totalCombined || 0;
          const totalGanar =
            data.quiniela.combinaciones?.reduce(
              (sum: number, item: { momio: number }) => sum + item.momio * baseBalance,
              0
            ) || 0;

          result += `
            <div class="ticket-summary">
              <div class="amount-info">
                <span class="amount-label">Tu monto máximo a ganar lo verás reflejado en la boleta</span>
              </div>
            </div>`;
        }
        break;

      case 'multiple':
        momios = this.truncateToDecimals(totalMomio, 2) * totalInd;
        result += `
          <div class="ticket-summary">
            <div class="amount-info">
              <span class="amount-label">Monto máximo a ganar:</span>
              <span class="amount-value">$${this.truncateToDecimals(data.totalAmount, 2)}</span>
            </div>
          </div>`;
        break;

      case 'individual':
        break;
    }

    result += '</div>'; // Cierre de ticket-container
    return result;
  }

  truncateToDecimals(num: number, decimals: number) {
    const factor = Math.pow(10, decimals);
    return Math.trunc(num * factor) / factor;
  }
}
